export default __webpack_public_path__ + "static/media/commerical_img.557408ae.png";